// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 98vw;
  display: flex;
  box-shadow: 0px 15px 5px -15px #a09b9b;
  height: 10vh;
}
nav h1 {
  text-transform: uppercase;
  font-size: 2rem;
}
nav img {
  padding: 2%;
  width: 18%;
}
nav a {
  text-decoration: none;
  color: #1d1d1d;
}
nav .nav__icons {
  display: flex;
}
nav .nav__icons div {
  display: flex;
  align-items: center;
  margin: 10px;
  cursor: pointer;
}
nav .nav__icons div span {
  display: none;
}
nav .nav__icons div:hover {
  color: #bf1a1a;
}
@media (max-width: 690px) {
  nav h1 {
    font-size: 1.2rem;
  }
  nav img {
    width: 40%;
  }
  nav .nav__icons div {
    margin: 3px;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  nav img {
    width: 40%;
  }
}
@media (min-width: 851px) {
  nav .nav__icons div span {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/nav.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAEA;ECuEI,aAAA;EACA,mBAAA;EACA,8BAAA;EDvEA,WAAA;EACA,aAAA;EACA,sCAAA;EACA,YAAA;AACJ;AACI;EACI,yBAAA;EACA,eAAA;AACR;AAEI;EACI,WAAA;EACA,UAAA;AAAR;AAGI;EACI,qBAAA;EACA,cCpBE;ADmBV;AAII;EACI,aAAA;AAFR;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AADZ;AAEY;EACI,aAAA;AAAhB;AAGY;EACI,cCpCR;ADmCR;AAMI;EACI;IACI,iBAAA;EAJV;EAOM;IACI,UAAA;EALV;EASU;IACI,WAAA;EAPd;AACF;AAWI;EACI;IACI,UAAA;EATV;AACF;AAYI;EAGY;IACI,aAAA;EAZlB;AACF","sourcesContent":["@import \"./variables.scss\";\n\nnav {\n    @include rowBetween;\n    width: 98vw;\n    display: flex;\n    box-shadow: 0px 15px 5px -15px #a09b9b;\n    height: 10vh;\n\n    h1 {\n        text-transform: uppercase;\n        font-size: 2rem;\n    }\n\n    img {\n        padding: 2%;\n        width: 18%;\n    }\n\n    a {\n        text-decoration: none;\n        color: $rtBlack;\n    }\n\n    .nav__icons {\n        display: flex;\n        div {\n            display: flex;\n            align-items: center;\n            margin: 10px;\n            cursor: pointer;\n            span {\n                display: none;\n            }\n\n            &:hover {\n                color: $rtRed;\n            }\n        }\n    }\n\n    @media (max-width: $mobile) {\n        h1 {\n            font-size: 1.2rem;\n        }\n\n        img {\n            width: 40%;\n        }\n\n        .nav__icons {\n            div {\n                margin: 3px;\n            }\n        }\n    }\n\n    @media (min-width: $tabletMin) and (max-width: $tabletMax) {\n        img {\n            width: 40%;\n        }\n    }\n\n    @media (min-width: $landsTabletMin) {\n        .nav__icons {\n            div {\n                span {\n                    display: flex;\n                }\n            }\n        }\n    }\n}\n","$rtRed: #bf1a1a;\n$rtBlack: #1d1d1d;\n$warning: #ff8808;\n$success: #00a74f;\n\n//Brand Colours\n$hr_dark_blue: #012748;\n$hr_blue: #0f4e6f;\n$hr_gold: #b66d2d;\n$hr_orange: #fe9816;\n$hr_yellow: #fede8c;\n\n//mobile breaks\n$mobile: 690px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin columnStartCenter {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnCenter {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnEnd {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-end;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin shadow {\n    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
